module.exports = __webpack_public_path__ + "static/media/Highwayman.4685fa3c.jpg";